// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"442":"beb493ea","530":"a04133e1","753":"63e993e6"}[chunkId] + ".chunk.css";
};